import React from "react";
import "../FBOHome.css";
import { Link, useNavigate } from "react-router-dom";
import ROUTE_PATHS from "../../../utils/routePaths";
import { FBO_TYPE } from "../../../utils/constants";
import NavigationBar from "../../../components/element/NavigationBar";
import FBOHeaderBar from "../../../components/element/FBOHeaderBar";
import lastSubmissionIcon from "../../../assets/images/last-submission-icon.svg";
import invoicingIcon from "../../../assets/images/reports-icon.svg";
import viewDataIcon from "../../../assets/images/view-data-icon.svg";
import GridComponent from "../Views/GridComponent";

const FuelRoyaltyHome = () => {
  const navigate = useNavigate();
  const gridItems = [
    {
      title: "Add/Submit",
      icon: lastSubmissionIcon,
      width: 23,
      height: 28,
    },
    { title: "Invoices", icon: invoicingIcon, width: 23, height: 28 },
    { title: "View Data", icon: viewDataIcon, width: 26, height: 26 },
  ];

  const handleCardOnClick = (index) => {
    if (index === 0) {
      navigate(ROUTE_PATHS.ADD_FUEL_METER);
    } else if (index === 1) {
      navigate(ROUTE_PATHS.INVOICES.replace(":aboType", FBO_TYPE.FUEL_ROYALTY));
    } else if (index === 2) {
      navigate(ROUTE_PATHS.VIEW_SUBMITTED_FUEL_READING);
    }
  };

  return (
    <div>
      <NavigationBar />
      <FBOHeaderBar
        title={"Fuel Royalty"}
        backContent={
          <div className="navigation-header">
            <Link to={ROUTE_PATHS.FBO_HOME} className="navigation-header-link">
              Home/
            </Link>
            Fuel Royalty
          </div>
        }
      />
      <div className="fee-type-home-container">
        <GridComponent gridItems={gridItems} onClickCard={handleCardOnClick} />
      </div>
    </div>
  );
};

export default FuelRoyaltyHome;
